



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// GETCONTACTUSSECTIONBYID
// GETCONTACTUSSECTIONBYID


const GETCONTACTUSSECTIONBYID= createAsyncThunk(
  "getContactUsSectionById/getContactUsSectionById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getContactUsSectionByIdSlice = createSlice({
  name: "getContactUsSectionByIdSlice",
  initialState: {
    getContactUsSectionById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetContactUsSectionById: (state) => {
        state.getContactUsSectionById.loading = false
        state.getContactUsSectionById.error = false
        state.getContactUsSectionById.data = []
        state.getContactUsSectionById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETCONTACTUSSECTIONBYID.fulfilled, (state, action) => {
      state.getContactUsSectionById = {
        ...state.getContactUsSectionById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCONTACTUSSECTIONBYID.pending, (state, action) => {
      state.getContactUsSectionById = {
        ...state.getContactUsSectionById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCONTACTUSSECTIONBYID.rejected, (state, action) => {
      state.getContactUsSectionById = {
        ...state.getContactUsSectionById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getContactUsSectionByIdAction = {
    GETCONTACTUSSECTIONBYID,
};

export { getContactUsSectionByIdAction };
export default getContactUsSectionByIdSlice.reducer;
export const {setInitialStateOfgetContactUsSectionById} = getContactUsSectionByIdSlice.actions
